import { useIsMobile } from '@melio/ar-domain';
import { Container, ExternalLayout } from '@melio/penny';
import { Payment } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { Footer } from './Footer';

export type GuestPaymentSuccessLayoutProps = {
  payment?: Payment;
  isLoading?: boolean;
  onBack?: VoidFunction;
  onDone?: VoidFunction;
};

export const GuestPaymentSuccessLayout = forwardRef<GuestPaymentSuccessLayoutProps>(
  ({ isLoading, children, ...props }, ref) => {
    const isMobile = useIsMobile();
    return (
      <ExternalLayout
        data-layout={GuestPaymentSuccessLayout.displayName}
        content={
          <Container
            backgroundColor="white"
            border={isMobile ? 'none' : 'regular'}
            data-layout="GuestPaymentSuccessLayout.Container"
            paddingX="xl"
            paddingY="xl"
          >
            {children}
          </Container>
        }
        footer={<Footer />}
        isLoading={isLoading}
        ref={ref}
        {...props}
      />
    );
  }
);
GuestPaymentSuccessLayout.displayName = 'GuestPaymentSuccessLayout';
